import { render } from "./NotFoundPage.vue?vue&type=template&id=ab26c722"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"
script.render = render

export default script